import { AxiosRequestConfig, AxiosResponse } from 'axios';

import PrerenderQueue from './prerender-queue';

export default class PrerenderInterceptor {
  public static requestHandler(request: AxiosRequestConfig) {
    const key = PrerenderQueue.getKey({
      method: request.method?.toUpperCase(),
      url: request.url,
      params: request.data,
    });

    PrerenderQueue.add(key);
    return request;
  }

  public static responseHandler(response: AxiosResponse<any>) {
    const key = PrerenderQueue.getKey({
      method: response?.config?.method?.toUpperCase(),
      url: response?.config?.url,
      params: response?.config?.data,
    });

    PrerenderQueue.remove(key);
    return response;
  }

  public static errorHandler(error: any) {
    const key = PrerenderQueue.getKey({
      method: error?.response?.config?.method?.toUpperCase(),
      url: error?.response?.config?.url,
      params: error?.response?.config?.data,
    });

    PrerenderQueue.remove(key);
    return Promise.reject(error);
  }
}
